/**
 * 全局"被踢下线"提示
 *
 * 底层 HTTP 客户端 (services/request/client.ts) 检测到账号在其他设备登录 (code 100005)
 * 时调用 showKickedOut(), 翻转响应式状态; 全局挂载的 <KickedOutDialog> 据此渲染。
 * 用户点确认后 confirmKickedOut() 兑现 Promise, 客户端再执行跳登录。
 *
 * 复用 GlobalToast/showToast 的单例模式, 避免在底层模块里直接弹 Element Plus 原生框。
 */
import { ref } from 'vue'

const visible = ref(false)
const message = ref('')
let resolver: (() => void) | null = null

/**
 * 显示"被踢下线"弹窗
 * @param msg 提示文案 (一般用后端返回的 msg, 缺省走 i18n 兜底)
 * @returns 用户点击确认后兑现的 Promise
 */
export function showKickedOut(msg?: string): Promise<void> {
  // 已在显示中 (并发请求风暴) → 复用同一个 Promise, 不重复弹
  if (visible.value && resolver) {
    return new Promise((resolve) => {
      const prev = resolver
      resolver = () => {
        prev?.()
        resolve()
      }
    })
  }
  message.value = msg || ''
  visible.value = true
  return new Promise((resolve) => {
    resolver = resolve
  })
}

/**
 * 用户点击确认 (由弹窗组件调用)
 */
export function confirmKickedOut(): void {
  visible.value = false
  const r = resolver
  resolver = null
  r?.()
}

export function useKickedOut() {
  return {
    visible,
    message,
    confirmKickedOut,
  }
}
